import {GameClient} from '../../gameClient/gameClient';

type SetGameClientSizeParams = {
    widthPercent: number,
    heightPercent: number
};

export class SetGameClientSize {
    // eslint-disable-next-line class-methods-use-this
    public async handle(_data: SetGameClientSizeParams) {
        GameClient.setClientSize(_data.widthPercent, _data.heightPercent);
    }
}
